import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: { main: '#A3271F', contrastText: '#ffffff' },
        secondary: { main: '#2C5B62', contrastText: '#ffffff' },
        error: { main: '#A3271F', contrastText: '#ffffff' },
        info: { main: '#cccccc', contrastText: '#ffffff' },
        background: {
            default: '#fafafa',
        },
        text: {
            primary: '#58585A',
        },
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: '#e2c5c4',
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '& .MuiTableCell-root .hover-actions': {
                        display: 'none',
                    },
                    '&:hover .MuiTableCell-root .hover-actions': {
                        display: 'block',
                    },
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    backgroundColor: '#A3271F',
                    color: '#ffffff',
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                h1: {
                    display: 'inline-flex',
                    verticalAlign: 'middle',
                    fontSize: '32px',
                    fontWeight: 'bold',
                    '& .MuiSvgIcon-root': {
                        fontSize: '32px',
                        marginRight: '12px',
                    },
                },
                h2: {
                    display: 'inline-flex',
                    verticalAlign: 'middle',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    '& .MuiSvgIcon-root': {
                        fontSize: '32px',
                        marginRight: '12px',
                    },
                },
                subtitle1: {
                    color: '#58585A',
                    fontSize: '20px',
                    fontWeight: 'normal',
                },
                h3: {
                    display: 'inline-flex',
                    verticalAlign: 'middle',
                    fontSize: '24px',
                    fontWeight: 'normal',
                    '& .MuiSvgIcon-root': {
                        fontSize: '24px',
                        marginRight: '8px',
                    },
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                root: {
                    '& .MuiDrawer-paper': {
                        backgroundColor: '#A3271F',
                        color: '#ffffff',
                        padding: '0px 8px 0px 20px',
                    },
                    '& .MuiDrawer-paper .MuiButtonBase-root': {
                        color: '#ffffff',
                        fontSize: '16px',
                        textTransform: 'none',
                    },
                    '& .MuiDrawer-paper .MuiButtonBase-root.nav-button': {
                        padding: '8px',
                        marginLeft: '-8px',
                        justifyContent: 'start',
                    },
                    '& .MuiDrawer-paper .MuiButtonBase-root.nav-button.full-width': {
                        padding: '8px 12px',
                        marginLeft: '-12px',
                        width: 'calc(100% + 12px)',
                    },
                    '& .MuiDrawer-paper .MuiButtonBase-root.nav-button:hover': {
                        backgroundColor: '#D7776E',
                    },
                    '& .MuiDrawer-paper .MuiButtonBase-root .MuiSvgIcon-root': {
                        fontSize: '32px',
                    },
                    '& .MuiDrawer-paper .MuiButtonBase-root .MuiButton-iconSizeMedium': {
                        marginRight: '24px',
                    },
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: '8px 24px',
                    '& .MuiButton-root': {
                        minWidth: '100px',
                    },
                    '& > :not(:first-of-type)': {
                        marginLeft: '24px',
                    },
                },
            },
        },
    },
});

export default theme;
